import React from "react";
import {Box, Button, Typography} from "@mui/material";
import {TEmailTemplateComponentType} from "../../interfaces/email";
import {useTranslation} from "react-i18next";
import {INSERTABLE_TYPES, TYPE_ICONS} from "./EmailTemplateComponentBlock";

type EmailTemplateAddBlockProps = {
  onAdd: (type: TEmailTemplateComponentType) => void;
};

export default function EmailTemplateAddBlock({onAdd}: EmailTemplateAddBlockProps): JSX.Element {
  const {t} = useTranslation();
  return (
    <Box
      sx={{
        width: "7vw",
        flexShrink: 0,
        borderRight: "1px solid",
        borderColor: "ornament.dark",
        backgroundColor: "ornament.light",
        display: "flex",
        flexDirection: "column",
        overflowY: "auto",
      }}
    >
      {INSERTABLE_TYPES.map((type) => (
        <Button
          key={type}
          onClick={(): void => onAdd(type)}
          sx={{
            width: "100%",
            minWidth: 75,
            minHeight: 90,
            p: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
            textTransform: "none",
            borderRadius: 0,
            borderTop: "1px solid transparent",
            borderBottom: "1px solid transparent",
            color: "neutral.main",
            "&:hover": {
              backgroundColor: "primaryLight.light",
              borderColor: "primaryLight.dark",
            },
          }}
        >
          {TYPE_ICONS[type]}
          <Typography variant="body2" sx={{textAlign: "center", fontWeight: "bold"}}>
            {t(`email_templates.components.types.${type}`)}
          </Typography>
        </Button>
      ))}
    </Box>
  );
}